export const organizationLabel = (grant) => grant.organization_name
  || (grant.organization_id ? 'Archived organization' : null);

export const contactLabel = (grant) => grant.primary_fan_name
  || (grant.primary_fan_id ? 'Unnamed contact' : null);
